import { MdExpandMore } from 'react-icons/md';

interface LoadMoreButtonProps {
  hasMore: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => void;
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  hasMore,
  isLoadingMore,
  onLoadMore,
}) => {
  if (!hasMore) return null;

  return (
    <div className="flex justify-center mt-4">
      <button
        onClick={onLoadMore}
        disabled={isLoadingMore}
        className="flex items-center gap-2 px-6 py-2 rounded border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        {isLoadingMore ? (
          'Cargando...'
        ) : (
          <>
            Cargar más
            <MdExpandMore size={18} />
          </>
        )}
      </button>
    </div>
  );
};

export default LoadMoreButton;
